<template>
  <b-table
    :items="status"
    :fields="fields"
    :busy="isLoading"
    show-empty
    fixed
    responsive="md"
    table-class="text-center"
    thead-class="text-center"
  >
    <template #table-busy>
      <AppSpinner
        class="mx-auto my-2 text-secondary"
        size="4"
      />
    </template>

    <template #cell(status)="data">
      <div class="text-center">
        <i v-if="data.value" :class="[$getConst.icons.check, 'text-success  fa-2x']"/>
        <i v-else :class="[$getConst.icons.close, 'text-danger fa-2x']"/>
      </div>
    </template>
  </b-table>
</template>

<script>
  import {getNavStatusHistory} from "../../../../api/scopes.api";
  import AppSpinner from "../../../../components/common/utils/AppSpinner";

  export default {
    name: "NavStatusHistory",
    components: {AppSpinner},
    props: {
      scope_id: null
    },
    data() {
      return {
        isLoading: false,
        status: null,
        fields: [
          {
            key: 'created_at',
            label: this.$t(this.$getConst.pages.nav_status_history.nav_status_test_date),
            formatter: (value, key, item) => {
              const date = new Date(value);
              return date.toLocaleString()
            },
          },
          { key: 'duration', label: this.$t(this.$getConst.pages.nav_status_history.nav_status_test_response_time) },
          {
            key: 'status',
            label: this.$t(this.$getConst.pages.nav_status_history.nav_status_test_result),
            formatter: (value, key, item) => {
              return value.toLowerCase() === "success"
            },
          },
        ]
      }
    },
    methods: {
      getNavStatusHistory() {
        this.isLoading = true;
        getNavStatusHistory(this.scope_id).then(
          (response) => {
            this.status = response.data;
            this.isLoading = false;
          },
          () => {
            this.isLoading = false;
            this.$snotify.error(this.$t(this.$getConst.pages.alerts.unknown_error));
          }
        )
      }
    },
    created() {
      this.getNavStatusHistory();
    }
  }
</script>

<style scoped>

</style>
